import React, { createContext, ReactNode } from "react";
import { configureApiClients, globalApiOptions } from "@bn/api";
import { mandatorsConfig } from "@bn/theming";
import { getDefaultMandatorSlug, getPortalRefreshUrl } from "@helpers";

const ApiContext = createContext<undefined>(undefined);

export const ApiProvider = ({ children }: { children: ReactNode }) => {
  const portalRefreshUrl = getPortalRefreshUrl();

  configureApiClients({
    apiBasePath: import.meta.env.VITE_APP_API_BASE_URL!,
    quotesBasePath: import.meta.env.VITE_APP_API_QUOTES_BASE_URL!,
    appPath: import.meta.env.VITE_APP_APP_URL!,
    apiV3BasePath: import.meta.env.VITE_APP_API_BASE_URL!,
    refreshTokenUrl:
      portalRefreshUrl ??
      mandatorsConfig[getDefaultMandatorSlug()]?.refreshTokenUrl,
    refreshTokenWithCredentials: !portalRefreshUrl,
  });

  if (!globalApiOptions) return null;

  return (
    <ApiContext.Provider value={undefined}>{children}</ApiContext.Provider>
  );
};
